<div class="panel mb-4">
  @if (!appSettings.isMobile()) {
    <div class="step-header">
      <h5 class="mb-0 text-dark fw-bold text-nowrap">
        <i class="fas fa-exchange-alt me-2 text-primary"></i>Solicitud de Transferencia
      </h5>
    </div>
  }
  <div class="step-body" [class.p-3]="appSettings.isMobile()">
    <app-party-form [partyForm]="partyForm()" [mode]="formMode.VIEW"></app-party-form>

    <div class="mt-3">
      <app-request-form
        [requestForm]="transferForm"
        [processSlug]="processSlug() || 'TRANSFER'"
        [currentEntityCode]="partyData()?.entityCode || currentEntityCode()">
      </app-request-form>
    </div>
  </div>

  @if (!appSettings.isMobile()) {
    <div class="step-footer justify-content-end">
      <button type="button" class="btn btn-primary btn-sm px-4" (click)="submitTransfer()" [disabled]="isSubmitting()">
        @if (isSubmitting()) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        } @else {
          <i class="fas fa-paper-plane me-1"></i>
        }
        Enviar Solicitud
      </button>
    </div>
  }
</div>

<app-mobile-footer [visible]="true">
  <button type="button" class="btn btn-primary btn-sm w-100" (click)="submitTransfer()" [disabled]="isSubmitting()">
    @if (isSubmitting()) {
      <span class="spinner-border spinner-border-sm me-1"></span>
    } @else {
      <i class="fas fa-paper-plane me-1"></i>
    }
    Enviar
  </button>
</app-mobile-footer>

<app-step-approval-modal
  [request]="approvalRequest()"
  [isProcessing]="isSubmitting()"
  (confirmed)="onStepApprovalConfirmed($event)">
</app-step-approval-modal>
